import { defineComponent as _defineComponent } from 'vue'
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { computed, onMounted, ref } from 'vue';

import ShopLogo from '@/components/redeem/shop-details/ShopLogo.vue';
import ApiErrorMessage from '@/components/widgets/ApiErrorMessage.vue';
import canRequestDonationReceipt from '@/composables/canRequestDonationReceipt';
import isPostalAddressRequired from '@/composables/isPostalAddressRequired';
import validateState from '@/composables/validateState';
import { t } from '~i18n';
import { ShopDetails } from '~model';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'RedeemForm',
  props: {
  /* Currently selected shop as object */
  shop: {
    type: Object as () => ShopDetails,
    default: null,
  },
  /* Array of errors */
  errors: {
    type: Array,
    default: null,
  },
},
  emits: [
  'next',
],
  setup(__props, { emit }) {

const props = __props





const getters = store?.getters;

const numberOfVouchers = ref(3);

const form = store.state.customer?.form;

const salutations = computed(() => getters.getSalutations);
// const voucher = computed(() => getters.getVoucher);
const voucherCategoryId = computed(() => getters.getVoucherCategoryId);
const showRechargeCheckbox = computed(() => getters.getShowRechargeCheckbox);
const showCustomerInquiry = computed(() => getters.getShowCustomerInquiry);
const showUseDataConfirmation = computed(() => getters.getShowUseDataConfirmation);
const showInfoBeforeRedeemButton = computed(() => getters.getShowInfoBeforeRedeemButton);
const showInfoAfterRedeemButton = computed(() => getters.getShowInfoAfterRedeemButton);
const voucherPartner = computed(() => getters?.getVoucherPartner);
const configId = computed(() => getters.getConfigId);
const country = computed(() => getters.getCountry);
const category = computed(() => getters.getCategory);
const voucherTokenPayload = computed(() => getters.getVoucherTokenPayload);
const isPaybackCustomer = computed(() => getters?.getIsPaybackCustomer);

const shopPhysical = computed(() => getters?.getShopPhysical);

const headline = computed((): string => {
  switch (true) {
    case shopPhysical.value:
      return 'wgs.std.pleaseEnterYourDataForProduct';

    case voucherCategoryId.value === 6:
      return 'wgs.std.pleaseEnterYourData';

    default:
      return 'wgs.std.giveDataGetCode';
  }
});

const submitButtonText = computed(() => (voucherCategoryId.value === 6 ? t('wgs.std.buttonAbsenden') : t('wgs.std.buttonSendAndGet')));

const shop = computed(() => props.shop);
const isNewShopCustomerInquiry = computed(() => shop.value.isNewShopCustomerInquiry);

const showAmexPaybackCheckbox = computed((): boolean => {
  const hasCategory = !category.value;
  const showForSites = (
    sites: string[],
  ) => sites.includes(configId.value);
  const showForCountries = (
    countries: string[],
  ) => countries.includes(country.value?.toLocaleLowerCase());
  const noThirdPartyRedeem = !('thirdPartyRedeem' in voucherTokenPayload.value);
  const inDateRange = new Date('2024-06-05') <= new Date() && new Date('2026-05-01 23:59:59') >= new Date();

  return (
    hasCategory &&
    showForCountries(['de']) &&
    showForSites(['wunschgutschein-de']) &&
    noThirdPartyRedeem &&
    inDateRange &&
    isPaybackCustomer.value
  );
});

const newShopCustomerOptions = computed(() => [
  { value: false, text: t('checkout.customerredeemtype.newShopCustomerOption1') },
  { value: true, text: t('checkout.customerredeemtype.newShopCustomerOption2') },
  { value: null, text: t('wgs.std.giveNoInfo') },
]);

const rules = {
  firstName: { required },
  lastName: { required },
  email: {
    required,
    email,
    // email: (value: string) => email(lowercaseFormatter(value)),
    emailDoesNotEndWithRu: (value: string) => value !== null && !value.endsWith('.ru'),
  },
  repeatEmail: {
    required,
    sameAsEmail: (value: string) => value !== null && value === form.email,
  },

  ...(isPostalAddressRequired(shop.value) ? {
    street: { required },
    streetNumber: { required },
    postalCode: { required },
    city: { required },
  } : {}),

  ...(isNewShopCustomerInquiry.value && showCustomerInquiry.value && !shopPhysical.value ? {
    newShopCustomer: {
      mustBeDefined: (value?: unknown) => typeof value !== 'undefined',
    },
  } : {}),

  ...(form.orderPrepaidVouchers ? {
    orderPrepaidVouchersConfirmation: {
      required,
    },
  } : {}),
};

const v$ = useVuelidate(rules, form);

const state = (v: string) => validateState(v, v$);

function tryGetCustomerDataFromToken() {
  const payload = voucherTokenPayload.value;
  if (payload.customer) {
    form.salutation = payload.customer.salutation;
    form.firstName = payload.customer.firstName;
    form.lastName = payload.customer.lastName;
    form.street = payload.customer.street;
    form.streetNumber = payload.customer.streetNumber;
    form.postalCode = payload.customer.postalCode;
    form.city = payload.customer.city;
    form.email = payload.customer.email;
    form.repeatEmail = payload.customer.email;
  }
}

function next() {
  v$.value.$touch();
  if (!v$.value.$invalid) {
    form.redemptionCompleted = true;
    emit('next');
  }
}

onMounted(() => {
  tryGetCustomerDataFromToken();
});

return { __sfc: true,props, emit, getters, numberOfVouchers, form, salutations, voucherCategoryId, showRechargeCheckbox, showCustomerInquiry, showUseDataConfirmation, showInfoBeforeRedeemButton, showInfoAfterRedeemButton, voucherPartner, configId, country, category, voucherTokenPayload, isPaybackCustomer, shopPhysical, headline, submitButtonText, shop, isNewShopCustomerInquiry, showAmexPaybackCheckbox, newShopCustomerOptions, rules, v$, state, tryGetCustomerDataFromToken, next, email, required, ShopLogo, ApiErrorMessage, canRequestDonationReceipt, isPostalAddressRequired, t }
}

})